import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { statisticsService } from 'services';
import { QueryContextFromKeys, QueryParamModel } from 'models';

type EstimationExclusionsQueryContexts = QueryContextFromKeys<typeof estimationExclusionsKeys>;

export const estimationExclusionsKeys = {
  all: [{ scope: 'estimationExclusions' }] as const,
  lists: () => [{ ...estimationExclusionsKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...estimationExclusionsKeys.lists()[0], params }] as const,
};

const fetchEstimationExclusionList = async ({
  queryKey: [{ params }],
}: EstimationExclusionsQueryContexts['list']) => statisticsService.getEstimationExclusions(params);

const exportEstimationExclusionList = async ({
  queryKey: [{ params }],
}: EstimationExclusionsQueryContexts['list']) =>
  statisticsService.exportEstimationExclusions(params);

export const useEstimationExclusionList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: estimationExclusionsKeys.list(params),
    queryFn: fetchEstimationExclusionList,
    enabled: isListEnabled(params),
  });
};

export const useExportEstimationExclusionList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: estimationExclusionsKeys.list(params),
    queryFn: exportEstimationExclusionList,
    enabled: false,
  });
};
